(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('heeman-product-form')) return;

    class HeemanProductForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.onSubmit = (event) => {
          event.preventDefault();
          this.add(false);
        };
        this.form.addEventListener('submit', this.onSubmit);

        /* Delegated: the actions region is replaced on every variant change. */
        this.onClick = (event) => {
          if (!event.target.closest('[data-buy-now]')) return;
          event.preventDefault();
          this.add(true);
        };
        this.addEventListener('click', this.onClick);

        this.onVariantChange = (event) => this.handleVariantChange(event);
        document.addEventListener('heeman:variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        if (this.form && this.onSubmit) {
          this.form.removeEventListener('submit', this.onSubmit);
        }
        if (this.onClick) this.removeEventListener('click', this.onClick);
        if (this.onVariantChange) {
          document.removeEventListener('heeman:variant:change', this.onVariantChange);
        }
      }

      /* ---- state ------------------------------------------------------ */
      button() {
        return this.querySelector('[data-atc]');
      }

      label() {
        return this.querySelector('[data-atc-label]');
      }

      /* Optimistic state until the picker's section fetch lands. */
      handleVariantChange(event) {
        const detail = event.detail || {};
        if (detail.sectionId !== this.dataset.sectionId) return;
        const button = this.button();
        const label = this.label();
        if (!button || !label) return;

        const variant = detail.variant;
        if (!variant) {
          button.disabled = true;
          label.textContent = this.dataset.unavailableText;
          return;
        }
        button.disabled = !variant.available;
        if (variant.available) {
          label.textContent = this.dataset.addText;
        } else {
          label.textContent = this.dataset.soldOutText;
        }
      }

      value(name) {
        const control = this.form.elements.namedItem(name);
        if (!control) return null;
        return control.value;
      }

      toast(message) {
        if (!message) return;
        document.dispatchEvent(
          new CustomEvent('heeman:toast', {
            detail: { message: message },
            bubbles: true
          })
        );
      }

      /* ---- the frozen add-to-cart flow ------------------------------- */
      async add(buyNow) {
        const button = this.button();
        const label = this.label();
        if (!button || button.disabled) return;

        const variantId = this.value('id');
        if (!variantId) return;

        let quantity = parseInt(this.value('quantity'), 10);
        if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

        const restore = label ? label.textContent : '';
        button.disabled = true;
        if (label) label.textContent = this.dataset.addingText;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              sections: 'cart-drawer,header'
            })
          });

          let payload = null;
          try {
            payload = await response.json();
          } catch (parseError) {
            payload = null;
          }

          if (!response.ok) {
            let reason = '';
            if (payload && payload.description) reason = payload.description;
            this.toast(reason || this.dataset.errorText);
            return;
          }

          if (buyNow) {
            window.location.href = '/checkout';
            return;
          }

          let cart = null;
          try {
            const cartResponse = await fetch('/cart.js');
            cart = await cartResponse.json();
          } catch (cartError) {
            cart = null;
          }

          if (cart) {
            document.dispatchEvent(
              new CustomEvent('heeman:cart:updated', {
                detail: { cart: cart },
                bubbles: true
              })
            );
          }

          if (document.body.dataset.cartType === 'drawer') {
            document.dispatchEvent(new CustomEvent('heeman:cart:open', { bubbles: true }));
          } else {
            this.toast(this.dataset.addedText);
          }
        } catch (error) {
          this.toast(this.dataset.errorText);
        } finally {
          const current = this.button();
          const currentLabel = this.label();
          if (current) current.disabled = false;
          if (currentLabel) currentLabel.textContent = restore;
        }
      }
    }

    customElements.define('heeman-product-form', HeemanProductForm);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    class HeemanCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        if (this.slides.length < 2) return; /* nothing to control */

        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dotsContainer = this.querySelector('[data-carousel-dots]');
        this.loop = this.hasAttribute('loop');
        this.dots = null;
        this.autoplayTimer = null;
        this.classList.add('carousel--ready');

        /* Seamless infinite loop: append a decorative copy of slide 1 so the
           track keeps moving FORWARD past the last slide, then snaps back to
           the identical-looking start in a single invisible jump. Gated on
           loop+autoplay so product rails are never cloned (duplicate ids). */
        this.clone = this.track.querySelector('[data-clone]');
        if (this.loop && this.hasAttribute('autoplay') && !this.clone) {
          const clone = this.slides[0].cloneNode(true);
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          /* the copy must not duplicate the page's h1 or any element ids */
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          clone.querySelectorAll('h1').forEach((h) => {
            const div = document.createElement('div');
            div.className = h.className;
            div.innerHTML = h.innerHTML;
            h.replaceWith(div);
          });
          this.track.append(clone);
          this.clone = clone;
        }

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.scrollBySlides(-1));
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.scrollBySlides(1));
        }

        /* Edge-disabled arrow states — rAF-throttled, passive */
        this.scrollTicking = false;
        this.track.addEventListener(
          'scroll',
          () => {
            if (this.scrollTicking) return;
            this.scrollTicking = true;
            requestAnimationFrame(() => {
              this.scrollTicking = false;
              this.updateArrows();
              this.snapCloneToStart();
            });
          },
          { passive: true }
        );
        /* Re-evaluate overflow/edge states when the rail resizes */
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);
        this.updateArrows();

        if (this.dotsContainer) this.buildDots();

        /* Dot sync: per-instance observer (root differs per carousel) */
        this.slideObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.setActive(this.slides.indexOf(entry.target));
              }
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.slideObserver.observe(slide));

        /* Autoplay: never starts unless motionOK() */
        if (this.hasAttribute('autoplay') && this.motionOK()) {
          this.interval =
            parseInt(this.getAttribute('autoplay-interval'), 10) || 5000;
          this.addEventListener('pointerenter', () => this.stopAutoplay());
          this.addEventListener('pointerleave', () => this.startAutoplay());
          this.addEventListener('focusin', () => this.stopAutoplay());
          this.addEventListener('focusout', () => this.startAutoplay());
          this.onVisibility = () => {
            if (document.hidden) {
              this.stopAutoplay();
            } else {
              this.startAutoplay();
            }
          };
          document.addEventListener('visibilitychange', this.onVisibility);
          this.startAutoplay();
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.slideObserver) this.slideObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.onVisibility) {
          document.removeEventListener('visibilitychange', this.onVisibility);
        }
      }

      motionOK() {
        /* motion.liquid may sit LATER in the concatenated snippet bundle, so
           Heeman.motionOK can be absent at upgrade time — treating that as
           "motion off" silently disarmed autoplay forever. Fall back to the
           native media query instead of assuming. */
        if (window.Heeman && typeof window.Heeman.motionOK === 'function') {
          return window.Heeman.motionOK();
        }
        return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      behavior() {
        return this.motionOK() ? 'smooth' : 'auto';
      }

      slideWidth() {
        return this.slides[0].getBoundingClientRect().width;
      }

      scrollBySlides(direction, wrap) {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const atStart = this.track.scrollLeft <= 1;
        const atEnd = this.track.scrollLeft >= max - 1;
        const shouldWrap = this.loop || wrap;
        if (shouldWrap && direction > 0 && atEnd) {
          /* No clone (rails): visible rewind is the honest fallback. With a
             clone this state only lasts one frame before snapCloneToStart. */
          this.track.scrollTo({ left: 0, behavior: this.clone ? 'auto' : this.behavior() });
          return;
        }
        if (shouldWrap && direction < 0 && atStart) {
          if (this.clone) {
            /* jump silently BEHIND the clone, then glide back one slide —
               reads as a seamless backward step from slide 1 to the last */
            this.track.scrollTo({ left: max, behavior: 'auto' });
            this.track.scrollBy({ left: -this.slideWidth(), behavior: this.behavior() });
          } else {
            this.track.scrollTo({ left: max, behavior: this.behavior() });
          }
          return;
        }
        this.track.scrollBy({
          left: direction * this.slideWidth(),
          behavior: this.behavior()
        });
      }

      snapCloneToStart() {
        if (!this.clone) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        /* The clone is pixel-identical to slide 1, so this jump is invisible */
        if (this.track.scrollLeft >= max - 1) {
          this.track.scrollTo({ left: 0, behavior: 'auto' });
          this.setActive(0);
        }
      }

      updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        /* No overflow: the track already fits — hide the arrows entirely */
        this.classList.toggle('carousel--fits', max <= 1);
        if (!this.prevButton && !this.nextButton) return;
        if (this.prevButton) {
          this.prevButton.toggleAttribute(
            'disabled',
            !this.loop && this.track.scrollLeft <= 1
          );
        }
        if (this.nextButton) {
          this.nextButton.toggleAttribute(
            'disabled',
            !this.loop && this.track.scrollLeft >= max - 1
          );
        }
      }

      buildDots() {
        this.dotsContainer.textContent = ''; /* safe re-init on reconnect */
        const template = this.getAttribute('data-label-goto') || 'Go to slide [n]';
        this.dots = this.slides.map((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'carousel__dot';
          dot.setAttribute('aria-label', template.replace('[n]', index + 1));
          dot.addEventListener('click', () => {
            this.track.scrollTo({
              left: slide.offsetLeft - this.track.offsetLeft,
              behavior: this.behavior()
            });
          });
          this.dotsContainer.append(dot);
          return dot;
        });
        this.setActive(0);
      }

      setActive(index) {
        if (index < 0 || !this.dots) return;
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          if (i === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      startAutoplay() {
        if (this.autoplayTimer || !this.interval || document.hidden) return;
        if (!this.motionOK()) return;
        this.autoplayTimer = window.setInterval(
          () => this.scrollBySlides(1, true), /* autoplay always wraps */
          this.interval
        );
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    if (!customElements.get('heeman-carousel')) {
      customElements.define('heeman-carousel', HeemanCarousel);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-line-item"] && !Shopify.designMode) return;
  try {
    (() => {
    /* Fires a heeman:* CustomEvent even if scripts.liquid has not run yet. */
    function dispatch(name, detail) {
      if (window.Heeman && typeof window.Heeman.dispatch === 'function') {
        window.Heeman.dispatch(name, detail);
        return;
      }
      document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
    }

    class HeemanCartItem extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.pending = false;
        this.boundChange = this.handleChange.bind(this);
        this.boundClick = this.handleClick.bind(this);
        this.addEventListener('change', this.boundChange);
        this.addEventListener('click', this.boundClick);
      }

      /* The quantity stepper (spec 06) dispatches a bubbling `change` on its
         inner input after every mutation — buttons and typing alike. Only the
         input's own name/value are read. */
      handleChange(event) {
        const input = event.target;
        if (!input || input.name !== 'updates[]') return;
        const quantity = parseInt(input.value, 10);
        if (Number.isNaN(quantity) || quantity < 0) return;
        this.mutate(quantity);
      }

      /* The remove control is a real link to item.url_to_remove (no-JS path);
         with JS it becomes an Ajax quantity-0 change. */
      handleClick(event) {
        if (!event.target.closest || !event.target.closest('[data-cart-remove]')) return;
        event.preventDefault();
        this.mutate(0);
      }

      mutate(quantity) {
        const key = this.dataset.lineKey;
        if (!key || this.pending) return;

        this.pending = true;
        this.setLoading(true);

        fetch(this.dataset.changeUrl || '/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: quantity })
        })
          .then((response) =>
            response
              .json()
              .catch(() => null)
              .then((data) => ({ ok: response.ok, data: data }))
          )
          .then((result) => {
            if (!result.ok || !result.data) {
              this.fail(result.data);
              return;
            }
            /* Both surfaces listen and re-render themselves from the server —
               the authoritative HTML clears this skeleton state. */
            this.pending = false;
            dispatch('heeman:cart:updated', { cart: result.data });
          })
          .catch(() => this.fail(null));
      }

      fail(data) {
        let message = '';
        if (data) message = data.description || data.message || '';
        if (!message) message = this.dataset.errorText || '';
        if (message) dispatch('heeman:toast', { message: message });
        this.pending = false;
        this.setLoading(false);
      }

      setLoading(state) {
        this.classList.toggle('is-loading', state);
        if (state) {
          this.setAttribute('aria-busy', 'true');
        } else {
          this.removeAttribute('aria-busy');
        }

        const surface = this.closest('form') || this.parentElement;
        if (!surface) return;
        surface.querySelectorAll('[data-cart-checkout]').forEach((button) => {
          if (state) {
            button.setAttribute('aria-disabled', 'true');
          } else {
            button.removeAttribute('aria-disabled');
          }
        });
      }
    }

    if (!customElements.get('heeman-cart-item')) {
      customElements.define('heeman-cart-item', HeemanCartItem);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (() => {
    /* Frozen contract with spec 17 (sections/predictive-search.liquid):
       the fragment contains exactly one [data-predictive-results] with
       role="listbox", and every row is an <a role="option"> in DOM order.
       The section id `predictive-search` must never be renamed. */
    const SUGGEST_URL =
      '/search/suggest?q=%QUERY%&section_id=predictive-search' +
      '&resources[type]=product,collection,query&resources[limit]=6';

    class HeemanPredictiveSearch extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.resultsBox = this.querySelector('[data-results]');
        this.statusLine = this.querySelector('[data-predictive-status]');
        if (!this.form || !this.input || !this.resultsBox) return;
        if (this.bound) return;
        this.bound = true;

        this.minChars = parseInt(this.dataset.minChars, 10) || 2;
        this.debounceMs = parseInt(this.dataset.debounce, 10) || 300;
        this.countTemplate = this.dataset.labelCount || '';
        this.listboxLabel = this.dataset.labelListbox || '';
        this.baseId = this.resultsBox.id || 'PredictiveResults';
        this.options = [];
        this.activeIndex = -1;
        this.isOpen = false;
        this.timer = null;
        this.controller = null;
        this.lastQuery = '';

        this.onInput = () => this.schedule();
        this.onKeydown = (event) => this.handleKeydown(event);
        this.onFocusOut = (event) => {
          if (event.relatedTarget && this.contains(event.relatedTarget)) return;
          this.close();
        };
        this.onDocumentClick = (event) => {
          if (this.contains(event.target)) return;
          this.close();
        };
        this.onSubmit = (event) => {
          const option = this.options[this.activeIndex];
          if (!option) return;
          event.preventDefault();
          this.go(option);
        };

        this.input.addEventListener('input', this.onInput);
        this.input.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusout', this.onFocusOut);
        this.form.addEventListener('submit', this.onSubmit);
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        this.abort();
        if (this.timer) window.clearTimeout(this.timer);
        if (this.onDocumentClick) {
          document.removeEventListener('click', this.onDocumentClick);
        }
        if (this.input && this.onInput) {
          this.input.removeEventListener('input', this.onInput);
          this.input.removeEventListener('keydown', this.onKeydown);
        }
        if (this.onFocusOut) this.removeEventListener('focusout', this.onFocusOut);
        if (this.form && this.onSubmit) {
          this.form.removeEventListener('submit', this.onSubmit);
        }
        this.bound = false;
      }

      /* ---- fetch lifecycle ------------------------------------------- */
      abort() {
        if (!this.controller) return;
        this.controller.abort();
        this.controller = null;
      }

      schedule() {
        if (this.timer) window.clearTimeout(this.timer);
        const query = this.input.value.trim();
        if (query.length < this.minChars) {
          this.abort();
          this.close();
          this.announce('');
          return;
        }
        this.timer = window.setTimeout(() => this.search(query), this.debounceMs);
      }

      async search(query) {
        this.abort();
        this.lastQuery = query;
        this.controller = new AbortController();
        const url = SUGGEST_URL.replace('%QUERY%', encodeURIComponent(query));

        let markup = '';
        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          markup = await response.text();
        } catch (error) {
          /* Aborted, offline, or spec 17's section not built yet (404):
             stay silent — the plain form submit still works. */
          return;
        }
        if (query !== this.lastQuery) return; /* superseded */
        this.mount(markup);
      }

      mount(markup) {
        let listbox = null;
        try {
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          listbox = parsed.querySelector('[data-predictive-results]');
        } catch (error) {
          listbox = null;
        }
        if (!listbox) {
          this.close();
          this.announce('');
          return;
        }

        const mounted = document.importNode(listbox, true);
        /* The fragment ships fixed ids; two search instances live on every
           page, so re-scope them to keep every DOM id unique. */
        mounted.id = this.baseId + '-listbox';
        if (this.listboxLabel && !mounted.hasAttribute('aria-label')) {
          mounted.setAttribute('aria-label', this.listboxLabel);
        }
        this.resultsBox.replaceChildren(mounted);

        this.options = Array.from(mounted.querySelectorAll('[role="option"]'));
        this.options.forEach((option, index) => {
          option.id = this.baseId + '-option-' + (index + 1);
          option.setAttribute('aria-selected', 'false');
          option.classList.remove('is-active');
        });

        if (this.options.length === 0) {
          this.close();
          this.announce('');
          return;
        }

        this.input.setAttribute('aria-controls', mounted.id);
        this.open();
        this.setActive(-1);
        this.announce(
          this.countTemplate.replace('[n]', String(this.options.length))
        );
      }

      /* ---- combobox state -------------------------------------------- */
      open() {
        this.resultsBox.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.isOpen = true;
      }

      close() {
        this.resultsBox.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.isOpen = false;
        this.activeIndex = -1;
      }

      announce(message) {
        if (!this.statusLine) return;
        this.statusLine.textContent = message;
      }

      setActive(index) {
        this.activeIndex = index;
        this.options.forEach((option, i) => {
          const active = i === index;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        const option = this.options[index];
        if (!option) {
          this.input.removeAttribute('aria-activedescendant');
          return;
        }
        this.input.setAttribute('aria-activedescendant', option.id);
        if (option.scrollIntoView) {
          option.scrollIntoView({ block: 'nearest' });
        }
      }

      move(step) {
        if (!this.isOpen || this.options.length === 0) return;
        const total = this.options.length;
        let next = this.activeIndex + step;
        if (next < 0) next = total - 1;
        if (next > total - 1) next = 0;
        this.setActive(next);
      }

      go(option) {
        const href = option.getAttribute('href');
        if (href) {
          window.location.assign(href);
          return;
        }
        option.click();
      }

      handleKeydown(event) {
        switch (event.key) {
          case 'ArrowDown':
            if (!this.isOpen) return;
            event.preventDefault();
            this.move(1);
            break;
          case 'ArrowUp':
            if (!this.isOpen) return;
            event.preventDefault();
            this.move(-1);
            break;
          case 'Enter': {
            const option = this.options[this.activeIndex];
            if (!this.isOpen || !option) return; /* plain form submit */
            event.preventDefault();
            this.go(option);
            break;
          }
          case 'Escape':
            if (this.isOpen) {
              event.preventDefault();
              this.close();
              return;
            }
            this.input.value = '';
            this.announce('');
            break;
          case 'Tab':
            this.close();
            break;
          default:
            break;
        }
      }
    }

    if (!customElements.get('heeman-predictive-search')) {
      customElements.define('heeman-predictive-search', HeemanPredictiveSearch);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const INTENT_DELAY = 150;

    class HeemanMegaMenu extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.mega__toggle');
        this.panel = this.querySelector('.mega__panel');
        if (!this.trigger || !this.panel) return;
        if (this.bound) return;
        this.bound = true;

        this.hoverTimer = null;
        this.hoverCapable = window.matchMedia('(hover: hover)').matches;

        this.onToggle = () => {
          if (this.classList.contains('is-open')) {
            this.close();
          } else {
            this.open();
          }
        };
        this.onKeydown = (event) => {
          if (event.key !== 'Escape') return;
          if (!this.classList.contains('is-open')) return;
          event.stopPropagation();
          this.close();
          this.trigger.focus();
        };
        this.onEnter = () => {
          if (!this.hoverCapable) return;
          this.clearHoverTimer();
          this.hoverTimer = window.setTimeout(() => this.open(), INTENT_DELAY);
        };
        this.onLeave = () => {
          if (!this.hoverCapable) return;
          this.clearHoverTimer();
          this.close();
        };
        this.onDocumentClick = (event) => {
          if (this.contains(event.target)) return;
          this.close();
        };
        this.onFocusOut = (event) => {
          if (event.relatedTarget && this.contains(event.relatedTarget)) return;
          this.close();
        };

        this.trigger.addEventListener('click', this.onToggle);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('pointerenter', this.onEnter);
        this.addEventListener('pointerleave', this.onLeave);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('click', this.onDocumentClick);

        HeemanMegaMenu.instances.add(this);
      }

      disconnectedCallback() {
        this.clearHoverTimer();
        HeemanMegaMenu.instances.delete(this);
        if (this.trigger && this.onToggle) {
          this.trigger.removeEventListener('click', this.onToggle);
        }
        if (this.onKeydown) {
          this.removeEventListener('keydown', this.onKeydown);
          this.removeEventListener('pointerenter', this.onEnter);
          this.removeEventListener('pointerleave', this.onLeave);
          this.removeEventListener('focusout', this.onFocusOut);
        }
        if (this.onDocumentClick) {
          document.removeEventListener('click', this.onDocumentClick);
        }
        this.bound = false;
      }

      clearHoverTimer() {
        if (!this.hoverTimer) return;
        window.clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }

      open() {
        this.clearHoverTimer();
        /* Only one panel open at a time — coordinated via the class-level
           registry, never a global. */
        HeemanMegaMenu.instances.forEach((instance) => {
          if (instance !== this) instance.close();
        });
        this.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.clearHoverTimer();
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
      }
    }

    HeemanMegaMenu.instances = new Set();

    if (!customElements.get('heeman-mega-menu')) {
      customElements.define('heeman-mega-menu', HeemanMegaMenu);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["motion"] && !Shopify.designMode) return;
  try {
    (() => {
    window.Heeman = window.Heeman || {};

    /* ---- 1. Motion gate ------------------------------------------------ */
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function motionOK() {
      if (reducedMotionQuery.matches) return false;
      if (!document.body) return true;
      return getComputedStyle(document.body).getPropertyValue('--motion').trim() !== '0';
    }
    window.Heeman.motionOK = motionOK;

    /* ---- 2. Pop micro-animation (badges, wishlist hearts) --------------- */
    function pop(el) {
      if (!el || !motionOK()) return;
      el.classList.remove('is-popping');
      void el.offsetWidth; /* restart the animation */
      el.classList.add('is-popping');
      el.addEventListener(
        'animationend',
        () => el.classList.remove('is-popping'),
        { once: true }
      );
    }
    window.Heeman.pop = pop;

    document.addEventListener('heeman:cart:updated', () => {
      document
        .querySelectorAll('[data-pop-on-cart-update]')
        .forEach((el) => pop(el));
    });

    /* ---- 3. Scroll reveal (ONE shared IntersectionObserver) ------------- */
    const REVEAL_STAGGER_MS = 60;
    const REVEAL_STAGGER_CAP = 8;
    let revealObserver = null;

    function getRevealObserver() {
      if (revealObserver) return revealObserver;
      revealObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target); /* fire once */
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
      );
      return revealObserver;
    }

    function scanReveals(root) {
      if (!document.documentElement.classList.contains('js')) return;
      if (!document.body) return;
      /* reveal--none on <body> means "no reveals" — only fade/rise are active */
      if (!/(^|\s)reveal--(fade|rise)(\s|$)/.test(document.body.className)) return;
      const scope = root || document;
      scope.querySelectorAll('[data-reveal-group]').forEach((group) => {
        group.querySelectorAll('[data-reveal]').forEach((item, index) => {
          const step = Math.min(index, REVEAL_STAGGER_CAP - 1);
          item.style.setProperty('--reveal-delay', step * REVEAL_STAGGER_MS + 'ms');
        });
      });
      scope.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((el) => {
        getRevealObserver().observe(el);
      });
    }
    window.Heeman.scanReveals = scanReveals;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scanReveals());
    } else {
      scanReveals();
    }
    document.addEventListener('shopify:section:load', (event) => {
      scanReveals(event.target);
    });

    /* ---- 4. <heeman-dialog> — drawer & modal choreography --------------- */
    class HeemanDialog extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.opener = null;

        /* Local listeners live on this subtree; bind once per node so a
           reconnect (editor drag/reorder) never doubles them */
        if (!this.listenersBound) {
          this.listenersBound = true;
          this.dialog.addEventListener('cancel', (event) => {
            event.preventDefault(); /* Esc: run exit animation first */
            this.close();
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close(); /* backdrop click */
          });
          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-dialog-close]')) this.close();
          });
        }

        const openOn = this.getAttribute('open-on');
        if (openOn && !this.onOpenEvent) {
          this.openOn = openOn;
          this.onOpenEvent = () => this.open();
          document.addEventListener(this.openOn, this.onOpenEvent);
        }
      }

      disconnectedCallback() {
        /* The open-on listener lives on document — remove it or every
           shopify:section:load reconnect leaks one more */
        if (this.onOpenEvent) {
          document.removeEventListener(this.openOn, this.onOpenEvent);
          this.onOpenEvent = null;
          this.openOn = null;
        }
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        this.opener = document.activeElement;
        this.dialog.showModal(); /* native focus trap + top layer */
        /* double rAF: ensure the pre-open styles are committed first */
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.dialog.classList.add('is-open'));
        });
      }

      close() {
        if (!this.dialog || !this.dialog.open) return;
        this.dialog.classList.remove('is-open');
        if (!motionOK()) {
          this.finishClose();
          return;
        }
        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          this.finishClose();
        };
        this.dialog.addEventListener('transitionend', finish, { once: true });
        window.setTimeout(finish, 400); /* safety net > --duration-slow */
      }

      finishClose() {
        this.dialog.close();
        if (this.opener && this.opener.isConnected) this.opener.focus();
        this.opener = null;
      }
    }
    if (!customElements.get('heeman-dialog')) {
      customElements.define('heeman-dialog', HeemanDialog);
    }

    /* Declarative openers: <button data-dialog-open="CartDrawer"> */
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-dialog-open]');
      if (!trigger) return;
      const target = document.getElementById(trigger.getAttribute('data-dialog-open'));
      if (target && typeof target.open === 'function') {
        event.preventDefault();
        target.open();
      }
    });

    /* ---- 5. <heeman-accordion> — animated <details> --------------------- */
    class HeemanAccordion extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.querySelector('.accordion__content');
        if (!this.details || !this.summary || !this.content) return;

        this.summary.addEventListener('click', (event) => {
          /* opening (or motion off): let the native toggle happen —
             the 0fr -> 1fr transition animates the open by itself */
          if (!this.details.open || !motionOK()) return;
          event.preventDefault(); /* intercept close for exit animation */
          if (this.details.classList.contains('is-closing')) return;
          this.details.classList.add('is-closing');
          let finished = false;
          const finish = () => {
            if (finished) return;
            finished = true;
            this.details.classList.remove('is-closing');
            this.details.removeAttribute('open');
          };
          this.content.addEventListener('transitionend', finish, { once: true });
          window.setTimeout(finish, 400);
        });
      }
    }
    if (!customElements.get('heeman-accordion')) {
      customElements.define('heeman-accordion', HeemanAccordion);
    }

    /* ---- 6. <heeman-sticky-header> --------------------------------------- */
    class HeemanStickyHeader extends HTMLElement {
      connectedCallback() {
        this.mode = this.getAttribute('data-sticky-mode') || 'on-scroll-up';
        if (this.mode === 'none') return;
        this.lastY = window.scrollY;
        this.ticking = false;
        /* Hide threshold = the header's own height (80px sane floor).
           Cached here + on resize so update() never reads layout per frame */
        this.hideThreshold = Math.max(this.offsetHeight, 80);
        this.sizeObserver = new ResizeObserver(() => {
          this.hideThreshold = Math.max(this.offsetHeight, 80);
        });
        this.sizeObserver.observe(this);
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => this.update());
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.sizeObserver) this.sizeObserver.disconnect();
      }

      update() {
        this.ticking = false;
        const y = window.scrollY;
        const goingDown = y > this.lastY;
        this.classList.toggle('is-stuck', y > 4);
        const hideForbidden =
          this.mode !== 'on-scroll-up' ||
          document.body.classList.contains('shopify-design-mode') ||
          document.querySelector('dialog[open], details[scroll-lock][open]') !== null;
        if (hideForbidden || y <= this.hideThreshold || !goingDown) {
          this.classList.remove('is-hidden');
        } else if (Math.abs(y - this.lastY) > 2) {
          this.classList.add('is-hidden');
        }
        this.lastY = y;
      }
    }
    if (!customElements.get('heeman-sticky-header')) {
      customElements.define('heeman-sticky-header', HeemanStickyHeader);
    }

    /* ---- 7. <heeman-marquee> --------------------------------------------- */
    class HeemanMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.list = this.querySelector('.marquee__list');
        if (!this.track || !this.list) return;
        if (!motionOK()) {
          this.classList.add('marquee--static');
          return;
        }
        const speed = parseFloat(this.getAttribute('data-speed')) || 60; /* px/s */
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.list.scrollWidth;
          if (width > 0) {
            this.track.style.setProperty('--marquee-duration', width / speed + 's');
          }
        });
        this.resizeObserver.observe(this.list);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }
    }
    if (!customElements.get('heeman-marquee')) {
      customElements.define('heeman-marquee', HeemanMarquee);
    }

    /* ---- 8. <heeman-countdown> -------------------------------------------- */
    class HeemanCountdown extends HTMLElement {
      connectedCallback() {
        this.ended = false;
        this.endsAt = Date.parse(this.getAttribute('data-ends') || '');
        if (Number.isNaN(this.endsAt)) {
          /* Blank/malformed data-ends: render NOTHING. Deliberately NOT the
             `hidden` attribute — [hidden] is the "ended + data-hide-on-end"
             marker that consumers key post-end copy off. A merchant typo must
             never surface "offer ended" UI. */
          this.setAttribute('data-state', 'invalid');
          this.style.display = 'none';
          return;
        }
        /* Valid date: clear any stale state from a previous connection */
        this.removeAttribute('data-state');
        this.style.removeProperty('display');
        this.classList.remove('is-ended');
        this.hidden = false;
        this.parts = {
          days: this.querySelector('[data-days]'),
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]')
        };
        this.timer = null;
        this.tick = this.tick.bind(this);
        this.onVisibility = () => {
          if (document.hidden) {
            this.stop();
          } else {
            this.start();
          }
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) {
          document.removeEventListener('visibilitychange', this.onVisibility);
        }
      }

      start() {
        if (this.timer || this.ended || document.hidden) return;
        this.tick();
        if (this.ended) return; /* tick() may have just finished it */
        this.timer = window.setInterval(this.tick, 1000);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      setPart(el, value) {
        if (!el) return;
        const text = String(value).padStart(2, '0');
        if (el.textContent === text) return;
        el.textContent = text;
        el.classList.remove('tick');
        void el.offsetWidth; /* restart the dip (1 Hz max — acceptable) */
        el.classList.add('tick');
      }

      tick() {
        const diff = this.endsAt - Date.now();
        if (diff <= 0) {
          this.stop();
          this.setPart(this.parts.days, 0);
          this.setPart(this.parts.hours, 0);
          this.setPart(this.parts.minutes, 0);
          this.setPart(this.parts.seconds, 0);
          if (!this.ended) {
            this.ended = true;
            this.classList.add('is-ended'); /* declarative post-end hook */
            this.dispatchEvent(
              new CustomEvent('heeman:countdown:ended', { bubbles: true })
            );
            if (this.hasAttribute('data-hide-on-end')) this.hidden = true;
          }
          return;
        }
        const total = Math.floor(diff / 1000);
        this.setPart(this.parts.days, Math.floor(total / 86400));
        this.setPart(this.parts.hours, Math.floor(total / 3600) % 24);
        this.setPart(this.parts.minutes, Math.floor(total / 60) % 60);
        this.setPart(this.parts.seconds, total % 60);
      }
    }
    if (!customElements.get('heeman-countdown')) {
      customElements.define('heeman-countdown', HeemanCountdown);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // Specs 02 and 03 also extend this global; load order varies.
    window.Heeman = window.Heeman || {};

    /* ---------------- window.Heeman.wishlist (frozen contract) --------- */
    if (!window.Heeman.wishlist) {
      var KEY = 'heeman:wishlist';
      // Session fallback for private browsing / quota errors.
      var memory = [];

      function readAll() {
        try {
          var raw = window.localStorage.getItem(KEY);
          if (!raw) {
            return memory.slice();
          }
          var parsed = JSON.parse(raw);
          if (!Array.isArray(parsed)) {
            return [];
          }
          return parsed.filter(function (handle) {
            return typeof handle === 'string' && handle.length > 0;
          });
        } catch (error) {
          return memory.slice();
        }
      }

      function persist(handles) {
        memory = handles.slice();
        try {
          window.localStorage.setItem(KEY, JSON.stringify(handles));
        } catch (error) {
          // Storage unavailable — in-memory only for this session.
        }
        try {
          document.dispatchEvent(
            new CustomEvent('heeman:wishlist:updated', {
              detail: { handles: handles.slice() },
              bubbles: true,
            })
          );
        } catch (error) {
          // CustomEvent unsupported — nothing to sync.
        }
      }

      function hasHandle(handle) {
        return readAll().indexOf(handle) !== -1;
      }

      function addHandle(handle) {
        if (!handle) return;
        var handles = readAll();
        if (handles.indexOf(handle) === -1) {
          handles.push(handle);
        }
        persist(handles);
      }

      function removeHandle(handle) {
        if (!handle) return;
        var handles = readAll().filter(function (item) {
          return item !== handle;
        });
        persist(handles);
      }

      function toggleHandle(handle) {
        if (hasHandle(handle)) {
          removeHandle(handle);
          return false;
        }
        addHandle(handle);
        return true;
      }

      window.Heeman.wishlist = {
        KEY: KEY,
        all: readAll,
        has: hasHandle,
        add: addHandle,
        remove: removeHandle,
        toggle: toggleHandle,
      };
    }

    /* ---------------- <heeman-wishlist-button> ------------------------- */
    if (!customElements.get('heeman-wishlist-button')) {
      customElements.define(
        'heeman-wishlist-button',
        class HeemanWishlistButton extends HTMLElement {
          connectedCallback() {
            this.button = this.querySelector('button');
            if (!this.button) return;

            this.handle = this.dataset.handle || '';
            this.labelAdd = this.dataset.labelAdd || '';
            this.labelRemove = this.dataset.labelRemove || '';

            this.onClick = this.onClick || this.handleClick.bind(this);
            this.onSync = this.onSync || this.sync.bind(this);

            this.button.addEventListener('click', this.onClick);
            document.addEventListener('heeman:wishlist:updated', this.onSync);
            this.sync();
          }

          disconnectedCallback() {
            if (this.button && this.onClick) {
              this.button.removeEventListener('click', this.onClick);
            }
            if (this.onSync) {
              document.removeEventListener('heeman:wishlist:updated', this.onSync);
            }
          }

          get api() {
            return window.Heeman && window.Heeman.wishlist;
          }

          sync() {
            if (!this.api || !this.button) return;
            var active = this.api.has(this.handle);
            this.classList.toggle('is-active', active);
            this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
            var label = active ? this.labelRemove : this.labelAdd;
            if (label) {
              this.button.setAttribute('aria-label', label);
            }
          }

          handleClick() {
            if (!this.api || !this.handle) return;
            this.api.toggle(this.handle);
            this.sync();
            if (window.Heeman && window.Heeman.pop) {
              window.Heeman.pop(this.button);
            }
          }
        }
      );
    }

    /* ---------------- <heeman-quick-add> ------------------------------- */
    if (!customElements.get('heeman-quick-add')) {
      customElements.define(
        'heeman-quick-add',
        class HeemanQuickAdd extends HTMLElement {
          connectedCallback() {
            this.button = this.querySelector('button');
            if (!this.button) return;
            this.defaultLabel = this.button.textContent.trim();
            this.onClick = this.onClick || this.handleClick.bind(this);
            this.button.addEventListener('click', this.onClick);
          }

          disconnectedCallback() {
            if (this.button && this.onClick) {
              this.button.removeEventListener('click', this.onClick);
            }
          }

          toast(message) {
            if (!message) return;
            document.dispatchEvent(
              new CustomEvent('heeman:toast', {
                detail: { message: message },
                bubbles: true,
              })
            );
          }

          async handleClick() {
            var variantId = this.dataset.variantId;
            if (!variantId || this.button.disabled) return;

            this.button.disabled = true;
            if (this.dataset.addingText) {
              this.button.textContent = this.dataset.addingText;
            }

            try {
              var response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  id: variantId,
                  quantity: 1,
                  sections: 'cart-drawer,header',
                }),
              });

              var payload = null;
              try {
                payload = await response.json();
              } catch (parseError) {
                payload = null;
              }

              if (!response.ok) {
                var reason = '';
                if (payload && payload.description) {
                  reason = payload.description;
                }
                this.toast(reason || this.dataset.errorText);
                return;
              }

              var cart = null;
              try {
                var cartResponse = await fetch('/cart.js');
                cart = await cartResponse.json();
              } catch (cartError) {
                cart = null;
              }

              if (cart) {
                document.dispatchEvent(
                  new CustomEvent('heeman:cart:updated', {
                    detail: { cart: cart },
                    bubbles: true,
                  })
                );
              }

              if (document.body.dataset.cartType === 'drawer') {
                document.dispatchEvent(
                  new CustomEvent('heeman:cart:open', { bubbles: true })
                );
              } else {
                this.toast(this.dataset.addedText);
              }
            } catch (error) {
              this.toast(this.dataset.errorText);
            } finally {
              this.button.disabled = false;
              this.button.textContent = this.defaultLabel;
            }
          }
        }
      );
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('heeman-product-gallery')) return;

    class HeemanProductGallery extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.gallery__carousel [data-track]');
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.frames = [];
        if (this.stage) {
          this.frames = Array.from(this.stage.children);
        }
        this.activeIndex = parseInt(this.dataset.activeIndex, 10) || 0;

        this.lightbox = null;
        const lightboxId = this.dataset.lightboxId;
        if (lightboxId) {
          this.lightbox = document.getElementById(lightboxId);
        }
        this.lightboxTrack = null;
        if (this.lightbox) {
          this.lightboxTrack = this.lightbox.querySelector('[data-track]');
        }
        this.counter = this.querySelector('[data-lb-counter]');

        this.bindThumbs();
        this.bindZoom();
        this.bindLightbox();
        this.observeStage();

        /* Server rendered slide 0 first; jump to the ?variant= media. */
        if (this.stage && this.activeIndex > 0) {
          this.scrollToIndex(this.stage, this.activeIndex, 'auto');
        }

        this.onVariantChange = (event) => this.handleVariantChange(event);
        document.addEventListener('heeman:variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        if (this.onVariantChange) {
          document.removeEventListener('heeman:variant:change', this.onVariantChange);
        }
        if (this.stageObserver) this.stageObserver.disconnect();
      }

      /* ---- thumbnails ------------------------------------------------ */
      bindThumbs() {
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const index = parseInt(thumb.dataset.index, 10) || 0;
            this.setActive(index);
            if (this.stage) this.scrollToIndex(this.stage, index);
          });
        });
      }

      setActive(index) {
        this.activeIndex = index;
        this.thumbs.forEach((thumb) => {
          const thumbIndex = parseInt(thumb.dataset.index, 10) || 0;
          if (thumbIndex === index) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      /* Keeps the thumb rail honest when the shopper swipes the track. */
      observeStage() {
        if (!this.stage || this.frames.length < 2) return;
        this.stageObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const index = this.frames.indexOf(entry.target);
              if (index > -1) this.setActive(index);
            });
          },
          { root: this.stage, threshold: 0.6 }
        );
        this.frames.forEach((frame) => this.stageObserver.observe(frame));
      }

      /* ---- hover zoom (transform-origin follows the cursor) ---------- */
      bindZoom() {
        this.querySelectorAll('.gallery__frame--zoomable').forEach((frame) => {
          frame.addEventListener('pointermove', (event) => {
            if (event.pointerType !== 'mouse') return;
            const box = frame.getBoundingClientRect();
            if (!box.width || !box.height) return;
            const x = ((event.clientX - box.left) / box.width) * 100;
            const y = ((event.clientY - box.top) / box.height) * 100;
            frame.style.setProperty('--zoom-x', x.toFixed(2) + '%');
            frame.style.setProperty('--zoom-y', y.toFixed(2) + '%');
          });
          frame.addEventListener('pointerleave', () => {
            frame.style.removeProperty('--zoom-x');
            frame.style.removeProperty('--zoom-y');
          });
        });
      }

      /* ---- lightbox (opened declaratively by heeman-dialog) ---------- */
      bindLightbox() {
        if (!this.lightboxTrack) return;

        this.querySelectorAll('[data-media-index]').forEach((frame) => {
          frame.addEventListener('click', () => {
            const index = parseInt(frame.dataset.mediaIndex, 10) || 0;
            requestAnimationFrame(() => {
              this.scrollToIndex(this.lightboxTrack, index, 'auto');
              this.updateCounter(index);
            });
          });
        });

        const prev = this.querySelector('[data-lb-prev]');
        const next = this.querySelector('[data-lb-next]');
        if (prev) prev.addEventListener('click', () => this.stepLightbox(-1));
        if (next) next.addEventListener('click', () => this.stepLightbox(1));

        this.lightboxTrack.addEventListener(
          'scroll',
          () => {
            if (this.counterTicking) return;
            this.counterTicking = true;
            requestAnimationFrame(() => {
              this.counterTicking = false;
              this.updateCounter(this.indexFromScroll(this.lightboxTrack));
            });
          },
          { passive: true }
        );
      }

      stepLightbox(direction) {
        const total = this.lightboxTrack.children.length;
        let index = this.indexFromScroll(this.lightboxTrack) + direction;
        if (index < 0) index = total - 1;
        if (index > total - 1) index = 0;
        this.scrollToIndex(this.lightboxTrack, index);
        this.updateCounter(index);
      }

      updateCounter(index) {
        if (!this.counter) return;
        const template = this.counter.dataset.counterTemplate || '[c] / [t]';
        this.counter.textContent = template
          .replace('[c]', String(index + 1))
          .replace('[t]', String(this.lightboxTrack.children.length));
      }

      /* ---- shared track helpers -------------------------------------- */
      indexFromScroll(track) {
        const slides = Array.from(track.children);
        let best = 0;
        let bestDistance = Infinity;
        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = index;
          }
        });
        return best;
      }

      scrollToIndex(track, index, behaviorOverride) {
        const slide = track.children[index];
        if (!slide) return;
        let behavior = behaviorOverride;
        if (!behavior) {
          behavior = 'auto';
          if (window.Heeman && window.Heeman.motionOK && window.Heeman.motionOK()) {
            behavior = 'smooth';
          }
        }
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: behavior });
      }

      /* ---- variant media sync ---------------------------------------- */
      handleVariantChange(event) {
        const detail = event.detail || {};
        if (detail.sectionId !== this.dataset.sectionId) return;
        const variant = detail.variant;
        if (!variant || !variant.featured_media) return;
        const target = this.querySelector(
          '[data-media-id="' + variant.featured_media.id + '"]'
        );
        if (!target || !this.stage) return;
        const index = this.frames.indexOf(target);
        if (index < 0) return;
        this.setActive(index);
        this.scrollToIndex(this.stage, index);
      }
    }

    customElements.define('heeman-product-gallery', HeemanProductGallery);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('heeman-quantity')) {
    class HeemanQuantity extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="number"]');
        if (!this.input) return;

        this.minusButton = this.querySelector('[data-minus]');
        this.plusButton = this.querySelector('[data-plus]');

        if (!this.bound) {
          this.bound = true;
          this.onMinus = () => this.stepBy(-1);
          this.onPlus = () => this.stepBy(1);
          this.onChange = () => this.normalize();
          this.onInput = () => this.syncButtons();
          this.onBlur = () => this.normalize();

          if (this.minusButton) this.minusButton.addEventListener('click', this.onMinus);
          if (this.plusButton) this.plusButton.addEventListener('click', this.onPlus);
          this.input.addEventListener('change', this.onChange);
          this.input.addEventListener('input', this.onInput);
          this.input.addEventListener('blur', this.onBlur);
        }

        this.syncButtons();
      }

      /* --- numeric helpers, all read from the input's own attributes --- */

      minValue() {
        const parsed = parseInt(this.input.getAttribute('min'), 10);
        return Number.isNaN(parsed) ? 0 : parsed;
      }

      maxValue() {
        const raw = this.input.getAttribute('max');
        if (raw === null || raw === '') return null;
        const parsed = parseInt(raw, 10);
        return Number.isNaN(parsed) ? null : parsed;
      }

      stepValue() {
        const parsed = parseInt(this.input.getAttribute('step'), 10);
        if (Number.isNaN(parsed)) return 1;
        if (parsed < 1) return 1;
        return parsed;
      }

      currentValue() {
        const parsed = parseInt(this.input.value, 10);
        return Number.isNaN(parsed) ? this.minValue() : parsed;
      }

      clamp(candidate) {
        const min = this.minValue();
        const max = this.maxValue();
        let next = candidate;
        if (!Number.isFinite(next)) next = min;
        if (next < min) next = min;
        if (max !== null && next > max) next = max;
        return next;
      }

      /* --- mutations --- */

      /* Button press: clamp, write, then emit one bubbling change on the input. */
      stepBy(direction) {
        const next = this.clamp(this.currentValue() + direction * this.stepValue());
        if (String(next) === this.input.value) {
          this.syncButtons();
          return;
        }
        this.input.value = next;
        this.syncButtons();
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* Typing/blur: the browser's own change event already bubbles, so only
         repair the value in place — never dispatch a second event. */
      normalize() {
        const next = this.clamp(this.currentValue());
        if (String(next) !== this.input.value) {
          this.input.value = next;
        }
        this.syncButtons();
      }

      syncButtons() {
        const value = this.currentValue();
        const max = this.maxValue();
        if (this.minusButton) {
          this.minusButton.disabled = value <= this.minValue();
        }
        if (this.plusButton) {
          if (max === null) {
            this.plusButton.disabled = false;
          } else {
            this.plusButton.disabled = value >= max;
          }
        }
      }
    }

    customElements.define('heeman-quantity', HeemanQuantity);

    /* Theme editor: pure custom elements re-upgrade on their own, but a
       re-injected section may carry server-rendered values that need their
       bound-button state recomputed. */
    document.addEventListener('shopify:section:load', (event) => {
      const scope = event.target instanceof Element ? event.target : document;
      scope.querySelectorAll('heeman-quantity').forEach((element) => {
        if (typeof element.syncButtons === 'function' && element.input) {
          element.syncButtons();
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scripts"] && !Shopify.designMode) return;
  try {
    window.Heeman = window.Heeman || {};

  /**
   * Section Rendering API helper.
   * Fetches `${url || location.pathname}?section_id=${sectionId}` (appending
   * with `&` when the url already has a query string) and resolves with a
   * DocumentFragment of the returned section HTML. Rejects on non-ok
   * responses and network errors — callers handle their own fallback.
   */
  window.Heeman.fetchSection = function (sectionId, url) {
    var base = url || window.location.pathname;
    var separator = '?';
    if (base.indexOf('?') > -1) {
      separator = '&';
    }
    var target = base + separator + 'section_id=' + encodeURIComponent(sectionId);

    return fetch(target)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Heeman.fetchSection: HTTP ' + response.status + ' for ' + target);
        }
        return response.text();
      })
      .then(function (html) {
        var template = document.createElement('template');
        template.innerHTML = html;
        return template.content;
      });
  };

  /**
   * Formats a cents amount using the shop money format embedded on
   * <body data-money-format>. Supports the four Shopify placeholder
   * variants; matches server-side `| money` output so JS-rendered prices
   * are indistinguishable from Liquid-rendered ones.
   */
  window.Heeman.formatMoney = function (cents) {
    var value = Number(cents);
    if (!isFinite(value)) {
      value = 0;
    }

    var format = '';
    if (document.body && document.body.dataset.moneyFormat) {
      format = document.body.dataset.moneyFormat;
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    if (!match) {
      if (format) {
        return format;
      }
      return (value / 100).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var negative = '';
      if (fixed.charAt(0) === '-') {
        negative = '-';
        fixed = fixed.slice(1);
      }
      var parts = fixed.split('.');
      var integerPart = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      var decimalPart = '';
      if (parts[1]) {
        decimalPart = decimal + parts[1];
      }
      return negative + integerPart + decimalPart;
    }

    var formatted;
    switch (match[1]) {
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount':
      default:
        formatted = formatWithDelimiters(value, 2, ',', '.');
        break;
    }

    return format.replace(placeholderRegex, formatted);
  };

  /** document.addEventListener sugar for the heeman:* event registry. */
  window.Heeman.on = function (name, handler) {
    document.addEventListener(name, handler);
  };

  /** Dispatches a bubbling CustomEvent on document. */
  window.Heeman.dispatch = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
  };

  /** 'drawer' | 'page' — live from <body data-cart-type>, default 'drawer'. */
  Object.defineProperty(window.Heeman, 'cartType', {
    configurable: true,
    get: function () {
      if (document.body && document.body.dataset.cartType) {
        return document.body.dataset.cartType;
      }
      return 'drawer';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('heeman-toast')) {
    customElements.define(
      'heeman-toast',
      class HeemanToast extends HTMLElement {
        connectedCallback() {
          this.boundShow = this.show.bind(this);
          document.addEventListener('heeman:toast', this.boundShow);
        }

        disconnectedCallback() {
          document.removeEventListener('heeman:toast', this.boundShow);
          clearTimeout(this.hideTimer);
          clearTimeout(this.rehideTimer);
        }

        show(event) {
          var message = '';
          if (event && event.detail && event.detail.message) {
            message = event.detail.message;
          }
          if (!message) {
            return;
          }

          var messageEl = this.querySelector('.toast__message');
          if (messageEl) {
            messageEl.textContent = message;
          }

          clearTimeout(this.hideTimer);
          clearTimeout(this.rehideTimer);

          this.removeAttribute('hidden');
          // Force a reflow so the enter transition plays from the resting state.
          void this.offsetWidth;
          this.classList.add('toast--visible');

          var self = this;
          this.hideTimer = setTimeout(function () {
            self.dismiss();
          }, 3500);
        }

        dismiss() {
          this.classList.remove('toast--visible');
          var self = this;
          this.rehideTimer = setTimeout(function () {
            self.setAttribute('hidden', '');
          }, 250);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('heeman-variant-picker')) return;

    class HeemanVariantPicker extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-variant-data]');
        this.variants = [];
        if (data) {
          try {
            this.variants = JSON.parse(data.textContent) || [];
          } catch (error) {
            this.variants = [];
          }
        }

        this.select = this.querySelector('[data-variant-select]');
        this.sectionId = this.dataset.sectionId;
        this.productUrl = this.dataset.productUrl || window.location.pathname;
        this.requestToken = 0;

        this.onChange = (event) => {
          if (!event.target.matches('[data-option-index]')) return;
          this.apply();
        };
        this.addEventListener('change', this.onChange);

        /* Without the pills (native select visible) keep JS out of the way,
           but still honour a manual select change. */
        if (this.select) {
          this.select.addEventListener('change', () => this.applyFromSelect());
        }

        this.refreshAvailability();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      /* ---- selection helpers ----------------------------------------- */
      selectedValues() {
        const groups = Array.from(this.querySelectorAll('[data-option-group]'));
        return groups.map((group) => {
          const checked = group.querySelector('[data-option-index]:checked');
          return checked ? checked.value : null;
        });
      }

      findVariant(values) {
        return (
          this.variants.find((variant) => {
            const options = variant.options || [];
            if (options.length !== values.length) return false;
            return options.every((option, index) => option === values[index]);
          }) || null
        );
      }

      applyFromSelect() {
        const id = parseInt(this.select.value, 10);
        const variant = this.variants.find((item) => item.id === id) || null;
        if (!variant) return;
        (variant.options || []).forEach((value, index) => {
          const group = this.querySelector('[data-option-group="' + index + '"]');
          if (!group) return;
          const radio = Array.from(group.querySelectorAll('[data-option-index]')).find(
            (input) => input.value === value
          );
          if (radio) radio.checked = true;
        });
        this.commit(variant);
      }

      apply() {
        const values = this.selectedValues();
        this.updateLegends(values);
        this.refreshAvailability();
        this.commit(this.findVariant(values));
      }

      updateLegends(values) {
        values.forEach((value, index) => {
          const target = this.querySelector('[data-selected-value="' + index + '"]');
          if (target && value !== null) target.textContent = value;
        });
      }

      /* Live struck-through state for combos that cannot be bought. */
      refreshAvailability() {
        const values = this.selectedValues();
        this.querySelectorAll('[data-value-for]').forEach((label) => {
          const index = parseInt(label.dataset.valueFor, 10);
          const candidate = values.slice();
          candidate[index] = label.dataset.value;
          const match = this.variants.find((variant) => {
            const options = variant.options || [];
            if (!variant.available) return false;
            return candidate.every((value, position) => {
              if (value === null) return true;
              return options[position] === value;
            });
          });
          label.classList.toggle('variant-picker__value--unavailable', !match);
          if (match) {
            label.removeAttribute('aria-disabled');
          } else {
            label.setAttribute('aria-disabled', 'true');
          }
        });
      }

      /* ---- commit: select value, URL, event, section swap ------------- */
      commit(variant) {
        /* Never disable the select: it is the form's only `id` control, and
           the Unavailable state is enforced on the submit button instead. */
        if (this.select && variant) {
          this.select.value = String(variant.id);
        }

        if (variant) this.updateUrl(variant);

        document.dispatchEvent(
          new CustomEvent('heeman:variant:change', {
            detail: { variant: variant, sectionId: this.sectionId },
            bubbles: true
          })
        );

        this.render(variant);
      }

      updateUrl(variant) {
        if (!window.history || !window.history.replaceState) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      render(variant) {
        if (!window.Heeman || !window.Heeman.fetchSection) return;
        if (!variant) {
          /* Nonexistent combo: no server state to fetch. buy-buttons puts
             itself into the "Unavailable" state off the dispatched event. */
          return;
        }

        const token = ++this.requestToken;
        const url = this.productUrl + '?variant=' + variant.id;

        window.Heeman.fetchSection(this.sectionId, url)
          .then((fragment) => {
            if (token !== this.requestToken) return;
            ['[data-price]', '[data-sku]', '[data-buy-buttons]'].forEach((selector) => {
              const source = fragment.querySelector(selector);
              const target = document.querySelector(
                '#shopify-section-' + this.sectionId + ' ' + selector
              );
              if (source && target) target.innerHTML = source.innerHTML;
            });
          })
          .catch(() => {
            /* Network failure: the form still posts the right variant id and
               the server validates availability. Nothing to repair. */
          });
      }
    }

    customElements.define('heeman-variant-picker', HeemanVariantPicker);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-items"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('heeman-wishlist')) {
    customElements.define(
      'heeman-wishlist',
      class HeemanWishlist extends HTMLElement {
        connectedCallback() {
          this.root = (this.dataset.root || '/').replace(/\/$/, '');
          this.grid = this.querySelector('[data-grid]');
          this.empty = this.querySelector('[data-empty]');
          this.loading = this.querySelector('[data-loading]');
          this.countEl = this.querySelector('[data-wishlist-count]');
          this.template = this.querySelector('[data-card-template]');
          this.cache = {};

          this.onUpdated = this.render.bind(this);
          document.addEventListener('heeman:wishlist:updated', this.onUpdated);
          this.render();
        }

        disconnectedCallback() {
          document.removeEventListener('heeman:wishlist:updated', this.onUpdated);
        }

        handles() {
          if (window.Heeman && window.Heeman.wishlist) {
            return window.Heeman.wishlist.all();
          }
          try {
            var parsed = JSON.parse(window.localStorage.getItem('heeman:wishlist'));
            return Array.isArray(parsed) ? parsed : [];
          } catch (error) {
            return [];
          }
        }

        fetchProduct(handle) {
          if (this.cache[handle]) {
            return this.cache[handle];
          }
          this.cache[handle] = fetch(this.root + '/products/' + encodeURIComponent(handle) + '.js')
            .then(function (response) {
              return response.ok ? response.json() : null;
            })
            .catch(function () {
              return null;
            });
          return this.cache[handle];
        }

        render() {
          var self = this;
          var handles = this.handles();
          var token = (this.renderToken = {});

          if (!handles.length) {
            this.showState([], 0);
            return;
          }

          Promise.all(
            handles.map(function (handle) {
              return self.fetchProduct(handle);
            })
          ).then(function (products) {
            if (token !== self.renderToken) return;
            self.showState(products.filter(Boolean), handles.length);
          });
        }

        showState(products, requested) {
          this.loading.hidden = true;
          var isEmpty = products.length === 0;
          this.empty.hidden = !isEmpty;
          this.grid.hidden = isEmpty;
          this.countEl.hidden = isEmpty;

          if (isEmpty) {
            this.grid.textContent = '';
            return;
          }

          var pattern = products.length === 1 ? this.dataset.countOne : this.dataset.countOther;
          this.countEl.textContent = pattern.replace('[count]', products.length);

          this.grid.textContent = '';
          for (var i = 0; i < products.length; i++) {
            this.grid.appendChild(this.buildCard(products[i]));
          }
        }

        buildCard(product) {
          var node = this.template.content.cloneNode(true);
          var image = node.querySelector('[data-card-image]');
          var title = node.querySelector('[data-card-title]');
          var price = node.querySelector('[data-card-price]');
          var compare = node.querySelector('[data-card-compare]');
          var remove = node.querySelector('[data-card-remove]');

          node.querySelector('[data-card-link]').href = product.url;
          title.href = product.url;
          title.textContent = product.title;

          if (product.featured_image) {
            var separator = product.featured_image.indexOf('?') === -1 ? '?' : '&';
            image.src = product.featured_image + separator + 'width=600';
            image.alt = product.title;
          } else {
            image.remove();
          }

          var format = function (cents) {
            if (window.Heeman && window.Heeman.formatMoney) {
              return window.Heeman.formatMoney(cents);
            }
            return (cents / 100).toFixed(0);
          };
          price.textContent = format(product.price);
          if (product.compare_at_price && product.compare_at_price > product.price) {
            compare.hidden = false;
            compare.textContent = format(product.compare_at_price);
          }

          var label = this.dataset.removeLabel + ' — ' + product.title;
          remove.setAttribute('aria-label', label);
          node.querySelector('[data-card-remove-label]').textContent = label;
          remove.addEventListener('click', function () {
            if (window.Heeman && window.Heeman.wishlist) {
              window.Heeman.wishlist.remove(product.handle);
            }
          });

          return node;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
